import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

/**
 * Vertical-align-middle: arrows converging on a horizontal center line
 * (Figma's "align middle" metaphor — unambiguous next to the pin-top and
 * pin-bottom icons).
 */
export const TextVerticalMiddleIcon = React.memo(
  function TextVerticalMiddleIcon({
    color = "currentColor",
    ...props
  }: IconProps) {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M2 7.5H13" stroke={color} strokeLinecap="round" />
        <path
          d="M7.5 1.75V5.25M7.5 5.25L5.75 3.5M7.5 5.25L9.25 3.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 13.25V9.75M7.5 9.75L5.75 11.5M7.5 9.75L9.25 11.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
